'use strict';

var Sugar = require('sugar-core'),
    _dateOptions = require('./var/_dateOptions');

module.exports = Sugar.Date.setOption;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/setOption.js
// module id = 594
// module chunks = 0